// src/app/ScrollToTop.tsx
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
	const { pathname, search, hash } = useLocation();

	useLayoutEffect(() => {
		// let in-page anchors (/#section) handle their own scroll
		if (hash) return;
		window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
	}, [pathname, search, hash]);

	return null;
}
